export default __webpack_public_path__ + "static/media/car.007f0aa7.jpg";